module.exports = __webpack_public_path__ + "media/cases-brand-avic-lazyload-161.67272276.mp4";